import { Box, Flex, Text, Tooltip } from '@optiaxiom/react';
import { IconCircleInfo } from '@optimizely/axiom-icons';

const HeaderWithTooltip = ({ label, info }: { label: string; info?: string }) => (
  <Flex flexDirection="row" alignItems="center" gap="4">
    <Text>{label}</Text>
    {info && (
      <Tooltip content={info}>
        <Box display="flex" alignItems="center">
          <IconCircleInfo size={14} />
        </Box>
      </Tooltip>
    )}
  </Flex>
);

export default HeaderWithTooltip;
